export default "__VITE_ASSET__DLpzS0Zx__"